import React from "react";
import { useSelector } from "react-redux";
import Capacity from "./Capacity";
import HCPCapacity from "./HCPCapacity";

const OrgCapacity = () => {
  const { organizationData } = useSelector((state) => state?.organization);
  const isHCP = organizationData?.organization_provider === 'HCP';

  return isHCP ? <HCPCapacity /> : <Capacity />;
};

export default OrgCapacity;
